import * as React from "react";
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { LoginLogoutButton, MainNavigation } from "soprasteria-ui-library/dist";
import { AuthConsumer, useAuth } from "../../App";
import { ClinicModel, MunicipalityModel, UserApi } from "../../api/UserApi";
import { UserContext, isInRole } from "../../contexts/UserContext";
import { MENUETTPORTAL, MENUETTPORTALKOMMUN } from "../../utils/ApplicationConstants";
import { CHANGE_APP_URL, MEN_PORTAL_WEB_BASE_URL } from "../../utils/Config";
import { MENUETTPORTALKOMMUN_BOENDESAMORDNARE, MENUETTPORTALKOMMUN_KOMMUNALADMINISTRATÖR, MENUETTPORTALKOMMUN_PRIVATANSVARIG, MENUETTPORTALMA, MENUETTPORTALVA } from "../../utils/RoleConstants";
import { CLINIC, MUNICIPALITY, ORGANISATION, SELECT_CLINIC } from "../../utils/RouteConstants";
import { GdprInformationModal } from "../GdprInformation/GdprInformationModal";
import { UserCard } from "../UserCard/UserCard";
import "./Navbar.scss";

export const Navbar: React.FunctionComponent<{}> = () => {
    const userInfo = React.useContext(UserContext);
    const history = useHistory();
    const auth = useAuth();
    const api = new UserApi(auth);
    const location = useLocation();
    const { pathname } = location;
    const hasRoleVA = isInRole(MENUETTPORTALVA, userInfo.roles ? userInfo.roles : []);
    const hasRoleMA = isInRole(MENUETTPORTALMA, userInfo.roles ? userInfo.roles : []);
    const hasRoleBoendesamordnare = isInRole(MENUETTPORTALKOMMUN_BOENDESAMORDNARE, userInfo.roles ? userInfo.roles : []);
    const hasRoleKommunalAdministratör = isInRole(MENUETTPORTALKOMMUN_KOMMUNALADMINISTRATÖR, userInfo.roles ? userInfo.roles : []);
    const hasRolePrivatAnsvarig = isInRole(MENUETTPORTALKOMMUN_PRIVATANSVARIG, userInfo.roles ? userInfo.roles : []);
    const [renderModal, setRenderModal] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [clinics, setClinics] = React.useState<ClinicModel[]>([]);
    const [municipalities, setMunicipalities] = React.useState<MunicipalityModel[]>([]);

    React.useEffect(() => {
        getClinics();
        getMunicipalities();
    }, [])

    React.useEffect(() => {
        if (pathname === `/${SELECT_CLINIC}`) {
            if (hasRoleVA) {
                history.push(`/${ORGANISATION}/${userInfo.organisationId}`);
            } else if (hasRoleMA) {
                history.push(`/${CLINIC}/${userInfo.clinicId}`);
            } else if (hasRoleBoendesamordnare || hasRoleKommunalAdministratör || hasRolePrivatAnsvarig) {
                history.push(`/${MUNICIPALITY}`);
            }
        }
    }, [userInfo.roles]);

    React.useEffect(() => {
        setRenderModal(userInfo.showGdprInformation);
    }, [userInfo.showGdprInformation]);

    const getClinics = () => {
        setIsLoading(true);
        api.getClinics(MENUETTPORTAL, (clinics: ClinicModel[]) => {
            setClinics(clinics);
        }, () => {
        }, () => {
            setIsLoading(false);
        });
    }

    const getMunicipalities = () => {
        setIsLoading(true);
        api.getMunicipalities(MENUETTPORTALKOMMUN, (municipalities: MunicipalityModel[]) => {
            setMunicipalities(municipalities);
        }, () => {
        }, () => {
            setIsLoading(false);
        });
    }

    const handlePubInformationLinkClick = () => {
        setRenderModal(true);
    }

    const closeModal = () => {
        setRenderModal(false);
        setSeenGdprInformation();
    }

    const setSeenGdprInformation = () => {
        api.setSeenGdprInformation(() => { }, undefined, undefined);
    }

    const showChangeEntity = () => {
        return !isLoading && (clinics && clinics.length > 1) || (municipalities && municipalities.length > 1) || (clinics && clinics.length > 0 && municipalities && municipalities.length > 0);
    }

    const changeEntityString = () => {
        var hasClinics = clinics && clinics.length > 0;
        var hasMunicipalities = municipalities && municipalities.length > 0;

        if (hasClinics && hasMunicipalities) {
            return "Välj rollgrupp";
        }
        else if (!hasClinics && hasMunicipalities) {
            return "Välj kommun/stadsdel";
        }
        else if (hasClinics && !hasMunicipalities) {
            return "Välj vårdgivare/mottagning";
        }

        return "Välj vårdgivare/mottagning";
    }

    return (
        <div>
            <MainNavigation
                imagePath={`${MEN_PORTAL_WEB_BASE_URL}/images/region-stockholm-logo.png`}
                rightContent=
                {
                    <>
                        <UserCard userInfo={userInfo} />
                        <div className="user-buttons text-right">
                            {showChangeEntity() &&
                                <>
                                    <NavLink to={`/${SELECT_CLINIC}`} className="nav-link" >{changeEntityString()}</NavLink>
                                    <span>|</span>
                                </>
                            }
                            <a href={`${CHANGE_APP_URL && CHANGE_APP_URL !== "" ? CHANGE_APP_URL : "#"}`} className="nav-link">Byt IT-system</a>
                            <span>|</span>
                            <a href="#" onClick={handlePubInformationLinkClick} className="nav-link">GDPR</a>
                            <span>|</span>
                            <LoginLogoutButton AuthConsumer={AuthConsumer} />
                        </div>
                    </>
                }
                informationTopRight="Dina aktiviteter i systemet loggas och kan komma att kontrolleras i efterhand"
            />
            {
                renderModal ?
                    <GdprInformationModal closeModal={closeModal} />
                    : null
            }
        </div>
    );
}
